<template>
    <div class="row">
        <div class="col-6">
            <div class="col-12 mb-1">
                <label class="form-label">Kod</label>
                <v-validator :errors="errors" parameter="Code" :watch="value.Code">
                    <input type="text" class="form-control" placeholder="Kod" v-model="value.Code" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Ad</label>
                <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                    <input type="text" class="form-control" placeholder="Ad" v-model="value.Name" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Entegre Depo Sınıfı <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="IntegratedStorageClassId" :watch="value.IntegratedStorageClassId">
                    <v-select-list v-model="integratedStorageClass" label="Name" placeholder="Entegre Depo Sınıfı Seçiniz" :options="integratedStorageClasses" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Depo Sınıfı <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="FuelStorageClassId" :watch="value.FuelStorageClassId">
                    <v-select-list v-model="storageClass" label="Name" placeholder="Depo Sınıfı Seçiniz" :options="storageClasses" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Yakıt Tipi <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="FuelStorageFuelTypeId" :watch="value.FuelStorageFuelTypeId">
                    <v-select-list v-model="fuelType" label="VisibleName" placeholder="Yakıt Tipi Seçiniz" :options="filteredFuelTypes" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Kapasite [lt] <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="Capacity" :watch="value.Capacity">
                    <VCurrencyInput :value="value.Capacity" @update-value="value.Capacity = $event" />
                </v-validator>
            </div>
        </div>
        <div class="col-6">
            <div class="col-12 mb-1">
                <label class="form-label">Şube <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="FuelStorageOwningBranchId" :watch="value.FuelStorageOwningBranchId">
                    <v-select-list v-model="branch" label="Name" placeholder="Şube Seçiniz" :options="branches" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">İl <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="ProvinceId" :watch="value.ProvinceId">
                    <v-select-list v-model="province" label="Name" placeholder="İl Seçiniz" :options="provinces" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Depo Yapısı <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="FuelStorageTypeId" :watch="value.FuelStorageTypeId">
                    <v-select-list v-model="fuelStorageType" label="Name" placeholder="Depo Yapısı Seçiniz" :options="fuelStorageTypes" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Depo Malzemesi <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="FuelStorageMaterialId" :watch="value.FuelStorageMaterialId">
                    <v-select-list v-model="fuelStorageMaterial" label="Name" placeholder="Depo Malzemesi Seçiniz" :options="fuelStorageMaterials" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Depo Hareketlilik Durumu <span class="text-danger">*</span></label>
                <v-validator :errors="errors" parameter="FuelStorageMobilityStatusId" :watch="value.FuelStorageMobilityStatusId">
                    <v-select-list v-model="fuelStorageMobilityStatus" label="Name" placeholder="Depo Hareketlilik Durumu Seçiniz" :options="fuelStorageMobilityStatuses" />
                </v-validator>
            </div>
            <!-- <div class="col-12 mb-1">
        <label class="form-label">Yakıt Miktarı [lt]</label>
        <v-validator :errors="errors" parameter="FuelQuantity" :watch="value.FuelQuantity">
          <input type="number" class="form-control" placeholder="Yakıt Miktarı" v-model.number="value.FuelQuantity">
        </v-validator>
      </div> -->
        </div>
    </div>
</template>

<script>
import VCurrencyInput from "@/components/VCurrencyInput.vue";

export default {
    components: {
        VCurrencyInput,
    },
    props: {
        value: Object,
        errors: Object,
        branches: Array,
        provinces: Array,
        fuelTypes: Array,
        integratedStorageClasses: Array,
        storageClasses: Array,
        fuelStorageTypes: Array,
        fuelStorageMaterials: Array,
        fuelStorageMobilityStatuses: Array,
    },
    computed: {
        storageClass: {
            get() {
                return this.storageClasses.find((c) => c.Id === this.value.FuelStorageClassId) || null;
            },
            set(value) {
                this.value.FuelStorageClassId = value?.Id || null;
            },
        },
        branch: {
            get() {
                return this.branches.find((b) => b.Id === this.value.FuelStorageOwningBranchId) || null;
            },
            set(value) {
                this.value.FuelStorageOwningBranchId = value?.Id || null;
            },
        },
        province: {
            get() {
                return this.provinces.find((p) => p.Id === this.value.ProvinceId) || null;
            },
            set(value) {
                this.value.ProvinceId = value?.Id || null;
            },
        },
        fuelType: {
            get() {
                return this.fuelTypes.find((f) => f.Id === this.value.FuelStorageFuelTypeId) || null;
            },
            set(value) {
                this.value.FuelStorageFuelTypeId = value?.Id || null;
            },
        },
        filteredFuelTypes() {
            if (!this.fuelTypes) return [];
            return this.fuelTypes;
            // .filter(type =>
            //   type.VisibleName === ' - ADBLUE' || type.VisibleName === ' - MOTORİN'
            // );
        },
        integratedStorageClass: {
            get() {
                return this.integratedStorageClasses.find((c) => c.Id === this.value.IntegratedStorageClassId) || null;
            },
            set(value) {
                this.value.IntegratedStorageClassId = value?.Id || null;
            },
        },
        fuelStorageType: {
            get() {
                return this.fuelStorageTypes.find((t) => parseInt(t.Value) === parseInt(this.value.FuelStorageTypeId)) || null;
            },
            set(value) {
                this.value.FuelStorageTypeId = parseInt(value?.Value) >= 0 ? parseInt(value.Value) : null;
            },
        },
        fuelStorageMaterial: {
            get() {
                return this.fuelStorageMaterials.find((m) => parseInt(m.Value) === parseInt(this.value.FuelStorageMaterialId)) || null;
            },
            set(value) {
                this.value.FuelStorageMaterialId = parseInt(value?.Value) >= 0 ? parseInt(value.Value) : null;
            },
        },
        fuelStorageMobilityStatus: {
            get() {
                return this.fuelStorageMobilityStatuses.find((s) => parseInt(s.Value) === parseInt(this.value.FuelStorageMobilityStatusId)) || null;
            },
            set(value) {
                this.value.FuelStorageMobilityStatusId = parseInt(value?.Value) >= 0 ? parseInt(value.Value) : null;
            },
        },
    },
};
</script>

<style scoped></style>
